import React from "react";
import ProtectedRoute from "@components/ProtectedRoute/ProtectedRoute";
import { Navigate, Route } from "react-router-dom";
import { type AppRoute } from "./types";

const maybeProtect = (route: AppRoute, children: React.ReactNode) => {
  if (!route.protected) return children;

  return (
    <ProtectedRoute requiredPermissions={route.requiredPermissions}>{children}</ProtectedRoute>
  );
};

export const renderRoute = (route: AppRoute): React.ReactElement => {
  const key = route.path ?? route.redirectTo ?? "index";
  const redirectElement = route.redirectTo ? <Navigate to={route.redirectTo} replace /> : undefined;

  if (route.index) {
    const element = redirectElement ?? route.element ?? null;
    return <Route key={key} index element={maybeProtect(route, element)} />;
  }

  if (!route.path) {
    throw new Error("Non-index routes must include a path.");
  }

  const routeElement = redirectElement ?? route.element ?? null;

  return (
    <Route key={key} path={route.path} element={maybeProtect(route, routeElement)}>
      {route.children?.map((child) => renderRoute(child))}
    </Route>
  );
};
